import React from 'react'
import { useNavigate } from 'react-router-dom'
import ASCLOGO from '../assets/asc-logo.jpg'

export default function Unauthorized() {
    const navigate = useNavigate()

    const handleGoBack = () => {
        navigate('/login')
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-200 px-4">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center border border-gray-100">
                {/* Logo */}
                <img src={ASCLOGO} alt="ASC Logo" className="mx-auto h-20 w-auto mb-6" />

                {/* Icon */}
                <div className="flex justify-center mb-4">
                    <div className="bg-red-100 p-4 rounded-full">
                        {/* <ShieldAlert className="text-red-600 w-10 h-10" /> */}
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-3xl font-bold text-gray-800 mb-2">Access Denied</h1>

                {/* Subtitle */}
                <p className="text-sm text-gray-500 mb-6">
                    Error 401 — You do not have permission to access this page.
                </p>

                {/* Description */}
                <p className="text-gray-600 mb-8">
                    Please log in with an authorized account or contact your administrator if you believe this is an
                    error.
                </p>

                {/* Button */}
                <button
                    onClick={handleGoBack}
                    className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition duration-200 shadow-md hover:shadow-lg"
                >
                    Return to Login
                </button>
            </div>
        </div>
    )
}
